import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import "@variphigen/shared-dashboards/dist/index.css";
import ModuleConfigBootstrap from "./bootstrap/ModuleConfigBootstrap";

import { StoreProvider } from "easy-peasy";
import { store } from "./store/easy-peasy";
import { AuthSessionProvider, bootstrapAppAuth } from "./auth/session";
import { registerAuthQueryClient } from "./auth/session/authQueryCache";
import { AuthTransitionScreen } from "./Components/AuthTransitionScreen";

const applicationId = process.env.REACT_APP_APPLICATION_ID ?? "";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 5 * 60 * 1000 },
  },
});

registerAuthQueryClient(queryClient);

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

function renderApp() {
  root.render(
    <React.StrictMode>
      <StoreProvider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <AuthSessionProvider>
              <ModuleConfigBootstrap applicationId={applicationId} />
            </AuthSessionProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </StoreProvider>
    </React.StrictMode>
  );
}

root.render(
  <React.StrictMode>
    <AuthTransitionScreen />
  </React.StrictMode>,
);

void bootstrapAppAuth({ renderApp });
